export const Colors = {
  mainColor: "#0d2c54",
  lightBlue: "#899ed1",
  extraLightBlue: "#D0E5FF",
  yellow: "#E7CF49",
  darkDarkBlue: "rgb(48, 90, 166)",
  newYellow: "#E7CF48",
  sea: "#025072",
  newLightBlue: "#0384bc",
  black: "#000",
  white: "#fff",
  LingopassLight: "#A47AB5",
  lightGreen: "#61B12F",
  gray: "#f5f5f5",
  lighterMainColor: "#E9F3E2",
};
